export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'Youtube certification',
            details : 'has successfully completed an Online Course Developed By Robi 10 minute School and offered through MuktoPaath On.',
            date : 'Aug 04, 2020',
            field : 'Automation',
            image : 'https://cdn.mos.cms.futurecdn.net/8gzcr6RpGStvZFA2qRt4v6.jpg'
        },
        {
            id : 2,
            title : 'Web Design & Development',
            details : 'Web Design & Development Online Course Successfully Completed To Fns Club & Institute.',
            date : '2019-2020',
            field : 'Automation',
            image : 'https://www.seekpng.com/png/detail/109-1090444_web-design-training-in-erode-web-design-logo.png'
        },
        {
            id : 3,
            title : 'Full Stack Web Development (MERN Stack)',
            details : 'Full Stack development (MERN Stack) Online Course Successfully Completed By Programming-Hero.',
            date : '2020-2021',
            field : 'Automation',
            image : 'https://stalwartlearning.com/wp-content/uploads/2019/06/Mern-Stack-Program.png'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/